<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">
        {{ usersSchool.name }}
      </h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      Number of Students: {{ usersSchool.totalStudentCount }}
    </div>
    <div class="row">
      Licence Expiry Date: {{ usersSchool.renewalDate | moment('DD-MM-YYYY') }}
    </div>
    <div class="row">
      Licence cost (including VAT):
      {{ usersSchool.licenseCostIncludingVat }} euro
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ManageSchool',
  computed: mapGetters({
    usersSchool: 'usersSchool',
  }),
  data() {
    return {
      schoolActions: ['Renew Licence'],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/schools/ManageSchool.vue